var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.93 123.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#c05458;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.47 122.05 37.73 102 37.73 61.89 72.47 41.84 107.2 61.89 107.2 102 72.47 122.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.73 61.89 72.47 81.94 107.2 61.89 141.93 41.84 107.2 21.79 72.47 1.73 37.73 21.79 3 41.84 37.73 61.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.47,
    y1: 81.94,
    x2: 72.47,
    y2: 122.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.73,
    y1: 61.89,
    x2: 37.73,
    y2: 21.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.2,
    y1: 61.89,
    x2: 107.2,
    y2: 21.79
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.27c53db13c3a5cca702a22c938e221c2.svg";
export { ForwardRef as ReactComponent };